import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { useGetProjectQuery } from "../../../app/services/projects";
import { useGetCurrentUserQuery } from "../../../app/accounts/authuser";
import { useProjectFieldSync } from "../../../hooks/useProjectFieldSync";
import GuideImage from "../../../components/guide-image/GuideImage";
import TitleBlock from "../../../components/block/TitleBlock";
import Input from "../../../components/form-item/Input";
import StatusIndicator from "../../../components/status-indicator/StatusIndicator";
import SvgLoadingAnimation from "../../../components/loading/index";

const ProjectEndClient = () => {
  const { projectId } = useParams();
  const { data: currentUserData } = useGetCurrentUserQuery();
  const { data: projectData, isLoading } = useGetProjectQuery(
    { project_id: projectId },
    { skip: !projectId || !currentUserData }
  );
  const { updateStatus, debouncedSave } = useProjectFieldSync(projectId);

  const [endClient, setEndClient] = useState("");
  const isComposingRef = useRef(false);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!initializedRef.current && projectData?.data?.project) {
      setEndClient(projectData.data.project.end_client || "");
      initializedRef.current = true;
    }
  }, [projectData]);

  const handleChange = (e) => {
    const value = e.target.value;
    setEndClient(value);
    if (!isComposingRef.current) {
      debouncedSave({ end_client: value });
    }
  };

  const handleCompositionStart = () => { isComposingRef.current = true; };
  const handleCompositionEnd = (e) => {
    isComposingRef.current = false;
    const value = e.target.value;
    setEndClient(value);
    debouncedSave({ end_client: value });
  };

  if (isLoading) return <SvgLoadingAnimation />;

  return (
    <div className="u-col u-w100 u-gap16">
      <TitleBlock
        title="エンドクライアント"
        description="このプロジェクトの成果物が、最終的に別の発注元（エンドクライアント）へ納品される場合は、その情報を登録できます。目的物や求められる品質基準の認識を、関係者間で揃えるのに役立ちます。"
      />
      <GuideImage name="project_endclient" />
      <Input
        type="text"
        label="エンドクライアント"
        option="optional"
        placeholder=""
        width="100%"
        maxlength={255}
        name="end_client"
        value={endClient}
        onChange={handleChange}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
      />
      <StatusIndicator status={updateStatus} />
    </div>
  );
};

export default ProjectEndClient;
